import castleService from '@/services/castle';

export default {
  install(app) {
    castleService.initialize();
    if (castleService.isInitialized) {
      app.config.globalProperties.$castle = castleService;
    }
  },
};
